// extracted by mini-css-extract-plugin
module.exports = {"stickTopRight":"HairdresserModal_stickTopRight__3kxgz","hairdresserNamePopin":"HairdresserModal_hairdresserNamePopin__3-n_W"};